<template>
    <div class="mb-4 font-semibold tracking-wide uppercase text-blueGray-700 bg-gray-75 px-4 py-3 leading-normal rounded-lg flex items-center relative">
        <slot></slot>
    </div>
</template>
